import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import NormalTable from "../../../../Component/NormalTable";
import { color } from "../../../../StyleData/Config";
import { fromUTC } from "../../../../utils/dateUtil";
import { woStatus } from "../../../../ConfigInfo/Info";

const LogWO = ({ data }) => {
  const [logData, setLogData] = useState([]);
  const [logGeneral, setLogGeneral] = useState([]);
  const [approvalLog, setApprovalLog] = useState([]);

  useEffect(() => {
    if (data) {
      fetchWorkOrderLogs(data);
    } else {
      setLogGeneral([]);
    }
  }, [data]);

  const fetchWorkOrderLogs = async (workOrderId) => {
    try {
      const getLogsLink = masterAPI.workOrder.getLogs;
      const res = await axiosPrivate.get(`${getLogsLink}/${workOrderId}`);
      console.log(res.data);
      if (res.data.result) {
        const getGeneralLog = res.data.result.workOrderLogList.filter((item) => item.logType.toUpperCase() === "GENERAL UPDATE");
        const getApprovalLog = res.data.result.workOrderLogList.filter((item) => item.logType.toUpperCase() === "WORKFLOW UPDATE");
        setLogGeneral(getGeneralLog || []);
        setApprovalLog(getApprovalLog || []);
      } else {
        setLogGeneral([]);
        setApprovalLog([]);
      }
    } catch (error) {
      setLogGeneral([]);
      setApprovalLog([]);
      console.log(error, "workOrderLogError");
    }
  };
  const columns = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Date",
      accessor: "createdDate",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
          >
            {cell.value !== null && cell.value !== undefined ? fromUTC(cell.value).tzString : "-"}
          </Typography>
        );
    },
  },
    {
      Header: "User",
      accessor: "workFlowupdateName", 
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: cell.value === "Approved" ? "green" : "red",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    
    {
      Header:"Reason",
      accessor:"reasonforRejected"
    }, 
    {
      Header: "Workflow For",
      accessor: "workFlowFor",
    },
    {
      Header: "Workflow Level",
      accessor: "workFlowLevel",
    }, 
    {
      Header: "Workflow Name",
      accessor: "workFlowName",
    },
  ];

  const columnsGeneral = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Date",
      accessor: "createdDate",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
          >
            {cell.value !== null && cell.value !== undefined ? fromUTC(cell.value).tzString : "-"}
          </Typography>
        );
      },
    },

    {
      Header: "User",
      accessor: "modifiedByName",
    },
    // {
    //   Header: "Log Type",
    //   accessor: "logtype",
    // },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color:
                cell.value === woStatus.COM ||
                cell.value === woStatus.OPEN ||
                cell.value === woStatus.APPR
                  ? "green"
                  : cell.value === woStatus.INPRG
                    ? "orange"
                    : "red",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header:"Reason",
      accessor:"reasonforRejected"
    }, 
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Box>
        <Typography
          sx={{
            color: color.sideTitleColor,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideWeightFont,
          }}
        >
          Log
        </Typography>
      </Box>
      <Paper sx={{ p: 1 }}>
        <Typography
          sx={{
            color: color.sideTitle2Color,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideFontWeight,
          }}
        >
          General Log
        </Typography>
        <Divider sx={{ m: "0.5rem 0 0.5rem 0" }} />
        <NormalTable columns={columnsGeneral} data={logGeneral} />
      </Paper>
      <Paper sx={{ p: 1 }}>
        <Typography
          sx={{
            color: color.sideTitle2Color,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideFontWeight,
          }}
        >
          Approval Log
        </Typography>
        <Divider sx={{ m: "0.5rem 0 0.5rem 0" }} />
        <NormalTable columns={columns} data={approvalLog} />
      </Paper>
    </Box>
  );
};

export default LogWO;
